import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { NotFoundPage } from 'libs.react';
import { useUserRoles } from 'libs.react_internal';
import { DataReportsProvider } from './contexts/data_reports/data_reports.context';
import { DataTransferTemplateProvider } from './contexts/data_transfer_template/data_transfer_template.context';
import { StudiesProvider } from './contexts/studies/studies.context';
const DataDashboardPage = lazy(() => import('./pages/data_dashboard/data_dashboard.page'));
const DataTransferTemplateViewPage = lazy(() => import('./pages/data_transfer_template/data_transfer_template_view.page'));
const ProvidersWrapper = ({ children }) => {
    return (_jsx(StudiesProvider, { children: _jsx(DataTransferTemplateProvider, { children: _jsx(DataReportsProvider, { children: children }) }) }));
};
export const DataManagementApp = () => {
    const navigate = useNavigate();
    const { isAdmin, isDataUser, isUserAndSiteManager } = useUserRoles();
    const canViewDataApp = isAdmin || isDataUser || isUserAndSiteManager;
    return (_jsx(ProvidersWrapper, { children: _jsxs(Routes, { children: [canViewDataApp && _jsx(Route, { index: true, path: 'dashboard', element: _jsx(DataDashboardPage, {}) }), _jsx(Route, { index: true, path: '/transfer-template/:transferTemplateId', element: _jsx(DataTransferTemplateViewPage, {}) }), _jsx(Route, { path: '*', element: _jsx(NotFoundPage, { goBack: () => navigate(-1) }) })] }) }));
};
export { DATA_MANAGEMENT_APP_FLAGS } from './constants/developer_flags.constants';
